export default __webpack_public_path__ + "static/media/sort-arrow-up-active.df622d08.svg";